import React from 'react';
import { Provider } from 'react-redux';

/**
 * @memberof module:React
 * @param {Object} props
 */
export default function OptionalReduxProvider(_ref) {
  var store = _ref.store,
    children = _ref.children;
  if (store === null) {
    return children;
  }
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, children);
}
OptionalReduxProvider.defaultProps = {
  store: null
};